Fancybox.bind('[data-fancybox="gallery"]', {
  // Your custom options for a specific gallery
});